import { render, staticRenderFns } from "./heading_with_content.vue?vue&type=template&id=4a149de7&scoped=true&"
import script from "./heading_with_content.vue?vue&type=script&lang=js&"
export * from "./heading_with_content.vue?vue&type=script&lang=js&"
import style0 from "./heading_with_content.vue?vue&type=style&index=0&id=4a149de7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a149de7",
  null
  
)

export default component.exports